<div class="container-fluid">

    <div class="header-image">
        <img alt="successful-image" class="header-image" height="216" width="270" src="../../../../../../../assets/gif/finzy-flex/portfolio-creation-success.svg">
    </div>

    <div class="header">
        <p>Yipeee…</p>
    </div>

    <div class="header-description">
        <p>You are all set to earn great returns!</p>
    </div>

    <div class="text">
        <p>Your funds will be allocated to loans and you can review the allocation from Loans tab.</p>
    </div>

    <div class="text-2">
        <p>Your Fund Allocation</p>

    </div>
    <div [ngClass]="this.productList.length == 2 ? 'max-width-for-two': ''">
        <app-products-invest-amount [productList]="this.productList">
        </app-products-invest-amount>
    </div>
    <div>
        <button type="button" class="track-btn" (click)="onClickTrackYourInvestment()">Track Your Investment</button>
    </div>
</div>
